import React, { createContext, useEffect } from 'react';
import useMainDataManager from '../hooks/useMainDataManager/useMainDataManager';
import useIsFormInstancePreview from '../hooks/useIsFormInstancePreview/useIsFormInstancePreview';

// @ts-ignore
const DataContext = createContext();

const DataProvider = ({ children }) => {
    const data = useMainDataManager();
    const {
        token,
        templateId,
        formGlobalId,
        fetchFormRequest,
        formInstanceId,
        formInstanceData,
        fetchLocalFormRequest,
        fetchCountries,
        setSearchRequest,
        signal,
    } = data;

    const isFormPreview = useIsFormInstancePreview();
    const formId = formInstanceData.id || formInstanceData.formId;

    /* Get template */
    useEffect(() => {
        const currentSignal = signal;
        if (token && templateId) {
            setSearchRequest();
        }
        return () => {
            if (token && templateId) {
                console.log('Unmount and cancel running axios request');
                currentSignal.current.cancel();
            }
        };
    }, [token, templateId, setSearchRequest, signal]);

    /* Get form instance */
    useEffect(() => {
        const currentSignal = signal;
        if (formGlobalId) {
            fetchFormRequest(formGlobalId);
        }
        return () => {
            if (formGlobalId) {
                console.log('Unmount and cancel running axios request');
                currentSignal.current.cancel();
            }
        };
    }, [formGlobalId, fetchFormRequest, signal]);

    /* Get form instance */
    useEffect(() => {
        const currentSignal = signal;
        if (formId) {
            fetchCountries(formId, isFormPreview);
        }
        return () => {
            if (formId) {
                console.log('Unmount and cancel running axios request');
                currentSignal.current.cancel();
            }
        };
    }, [fetchCountries, signal, formId, isFormPreview]);

    /* Get form instance */
    useEffect(() => {
        const currentSignal = signal;
        if (formInstanceId) {
            fetchLocalFormRequest(formInstanceId);
        }
        return () => {
            if (formInstanceId) {
                console.log('Unmount and cancel running axios request');
                currentSignal.current.cancel();
            }
        };
    }, [formInstanceId, fetchLocalFormRequest, signal]);

    return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
};

export { DataContext, DataProvider };
